module.exports = __webpack_public_path__ + "img/beforeLike.4bcd642f.png";